import React from "react";

// TODO: move this to core.js
function iterHighlightedRanges(
  length: number,
  indices: number[],
  cb: (rangeStart: number, rangeLen: number, highlighted: boolean) => void
) {
  let idx = 0;
  if (indices.length === 0) {
    cb(0, length, false);
    return;
  }

  let rangeStart = 0;
  let highlightedRange = false;
  for (let i = 0; i < length; i++) {
    if (i === indices[idx]) {
      if (highlightedRange) {
        // in highlighted range, all good
      } else {
        // not in highlighted range
        // we match highlighted index, but we're not in a highlighted range
        // submit old range, start a new highlighted one
        const rangeLen = i - rangeStart;
        if (rangeLen > 0) {
          cb(rangeStart, rangeLen, false);
        }
        rangeStart = i;
        highlightedRange = true;
      }
      idx++;
    } else {
      if (highlightedRange) {
        // in highlighted range
        // we don't match highlighted index, means highlighted range stops here
        const rangeLen = i - rangeStart;
        if (rangeLen > 0) {
          cb(rangeStart, rangeLen, true);
        }
        rangeStart = i;
        highlightedRange = false;
      } else {
        // not in highlighted range, all good
      }
    }
  }
  const rangeLen = length - rangeStart;
  if (rangeLen > 0) {
    cb(rangeStart, rangeLen, indices[indices.length - 1] === length - 1);
  }
}

export function fuzzyHighlight({ target, indexes }: { target: string; indexes: number[] }): JSX.Element {
  const out: (JSX.Element | string)[] = [];
  let idx = 0;
  iterHighlightedRanges(target.length, indexes, (rangeStart, rangeLen, highlighted) => {
    const text = target.substr(rangeStart, rangeLen);
    out.push(highlighted ? <mark key={idx++}>{text}</mark> : text);
  });
  return <span>{out}</span>;
}
